const common_banner_splide_elm = document.querySelector('.common_banner_splide')
if(common_banner_splide_elm){
  const speed = Number(common_banner_splide_elm.dataset.speed)
   const interval = Number(common_banner_splide_elm.dataset.interval) 
  const cb_splide = new Splide( common_banner_splide_elm, {
  type   : 'loop',
    arrows:false,
  pagination:false,
  autoplay: true,
  pauseOnHover: false,
  interval :interval ,
  speed    : speed
});
 cb_splide.mount();
}